<template>
  <div class="isolate-tag">
    <div class="tag mx-2" :class="[tagType]">
      <div class="text-capitalize">{{ content }}</div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  name: "Tag",
  props: {
    variant: {
      type: String,
      default: "active",
    },
    content: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const typeList = {
      active: "tag-active",
      static: "tag-static",
    };
    const tagType = computed(() => {
      return typeList[props.variant];
    });

    return {
      tagType,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.tag {
  padding: 0 5px 0 5px;
  font-size: 0.75rem;
  border-radius: 0 2px 2px 0;
  float: left;
  position: relative;
  border-width: 1px;
  border-style: solid;
}

.tag:after {
  content: "";
  width: 14px;
  height: 14px;
  transform: rotate(45deg);
  display: block;
  position: absolute;
  top: 2px;
  left: -7px;
  z-index: -1;
  border-radius: 0 2px;
  border-width: 1px;
  border-style: solid;
}

.tag-active {
  border-left: 0;
}

.tag-static {
  border-left: 0;
}

.isolate-tag {
  isolation: isolate;
}
</style>
